import Model from '../models/Model'

const extender = (...classes) => classes.reduce(aggregator, Model)
const aggregator = (allFunctions, soloFunction) => soloFunction(allFunctions)

export default extender
